// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"a7b12269","227":"ea40457f","237":"302ba332","453":"51d8bfbf","460":"040c7abe","816":"b6b31590","954":"5cdee904"}[chunkId] + ".chunk.js";
};